// extracted by mini-css-extract-plugin
module.exports = {"imageWrap":"PageSwitchable_imageWrap__3QOqu"};